import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';

interface LoadingIndicatorProps {
  icon: SvgIconComponent;
  message: string;
  minHeight?: string;
}

/**
 * Shared loading display: the screen's icon above a progress circle and the loading text.
 */
const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ icon: Icon, message, minHeight = '200px' }) => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight} role="status">
    <Box textAlign="center">
      <Icon sx={{ fontSize: 48, color: '#94a3b8', mb: 1 }} />
      <Box>
        <CircularProgress size={40} aria-label={message} sx={{ color: '#3b82f6' }} />
      </Box>
      <Box mt={2} color="#64748b">
        {message}
      </Box>
    </Box>
  </Box>
);

export default LoadingIndicator;
